module.exports = __webpack_public_path__ + "static/logo-c5ab9cb345cd8bf8f2c364531bbec8f9.svg";